import React, { useState, useContext } from 'react';

import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import CustomRowLabels from './CustomRowLabels';
import ManufacturerDetailsSubSection from './ManufacturerDetailsSubSection';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

interface ManufacturerSectionProps {}

const ManufacturerSection: React.FunctionComponent<ManufacturerSectionProps> = () => {
  let [expanded, setExpanded] = useState(true);

  let { chillerLog, prevChillerLog1, prevChillerLog2 } = useContext(ChillerLogsContext);

  const hasPreviousChillerLog1 = prevChillerLog1?.manufacturer_details?.length > 0;
  const hasPreviousChillerLog2 = prevChillerLog2?.manufacturer_details?.length > 0;

  return (
    chillerLog && (
      <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <AccordionSummary style={{ background: '#A21C37' }}>
          <h3 style={{ color: '#fff', fontWeight: 700 }}>Manufacturer Details ({chillerLog?.manufacturer_name})</h3>
        </AccordionSummary>
        <AccordionDetails style={{ margin: 0, padding: 0 }}>
          <Grid container display={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Grid item xs={2}>
              <CustomRowLabels data={chillerLog?.manufacturer_details} />
            </Grid>
            {hasPreviousChillerLog2 && (
              <Grid item xs={1}>
                <ManufacturerDetailsSubSection sectionChillerLog={prevChillerLog2} col={1} />
              </Grid>
            )}
            {hasPreviousChillerLog1 && (
              <Grid item xs={1} style={{ marginLeft: hasPreviousChillerLog2 ? '-20px' : 0 }}>
                <ManufacturerDetailsSubSection sectionChillerLog={prevChillerLog1} col={2} />
              </Grid>
            )}
            <Grid item xs={1} style={{ marginLeft: hasPreviousChillerLog1 ? '-20px' : 0 }}>
              {chillerLog?.manufacturer_details?.length > 0 && (
                <ManufacturerDetailsSubSection sectionChillerLog={chillerLog} col={3} />
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    )
  );
};

export default ManufacturerSection;
